import React from "react";
import UserRatingAndCurrentlyReading from "../shared/user_rating_and_currently_reading";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "FriendDetails",

  propTypes: {
    friendUser: GrPropTypes.user().isRequired,
    isMyFriend: React.PropTypes.bool.isRequired,
    ratingDetailsText: React.PropTypes.string,
    addFriendUrl: React.PropTypes.string,
    compareBooksUrl: React.PropTypes.string,
    currentlyReadingBook: GrPropTypes.book(),
  },

  renderAddFriendButtonOrPendingText(){
    if (this.props.isMyFriend) {
      return <div>
               <a href={this.props.compareBooksUrl}
                  className="gr-button u-marginTopMedium">
                Compare books
               </a>
             </div>;
    } else {
      return <div>
               <a href={this.props.addFriendUrl}
                  className="gr-button u-marginTopMedium">
                Add friend
               </a>
             </div>;
    }
  },

  render() {
    const user = this.props.friendUser;
    return (
      <div className="gr-newsfeedItem__details">
        <a href={user.profileUrl} className="gr-newsfeedItem__resourceNameLink">
          {user.viewableName}
        </a>
        <UserRatingAndCurrentlyReading ratingDetailsText={this.props.ratingDetailsText}
                                       currentlyReadingBook={this.props.currentlyReadingBook} />
        {this.renderAddFriendButtonOrPendingText()}
      </div>
    );
  },
});
